import React, { Component } from "react";
import { connect } from "react-redux";

class MerchantInfo extends Component {
    render() {
        const merchant = this.props.merchant;
        const officialUrl = this.props.officialUrl ? this.props.officialUrl : '' ;
        const merchantName = merchant && merchant.name;
        const merchantDescription = merchant && merchant.description;
        return (
            <div>
                <a href={officialUrl} target='_blank_' alt={merchantName}>{ merchantName }</a>
                <p className="mt-2">{ merchantDescription }</p>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
      merchant: state.merchants.merchantList[ownProps.merchantId]
    };
}

export default connect(mapStateToProps, null)(MerchantInfo);